import { ApplePay, GooglePay, PayPal, RecurlyContext } from 'features/checkout'
import { cn } from 'utils/classMerge'
import { Alert } from 'components/ui/alert'
import { getApiErrorText } from 'features/checkout/utils'
import { translate } from 'utils/translation'
import { useContextSave } from 'hooks/use-context-save'

type PaymentListProps = {
  source: string
}

export const PaymentList = ({ source }: PaymentListProps) => {
  const context = useContextSave(RecurlyContext)
  const { isLoading, serverError } = context

  const serverErrorMessage =
    serverError &&
    serverError?.message !==
      translate('old_lifetime_update_billing_info_modal') &&
    serverError?.message !== 'request_failed' &&
    serverError?.type !== 'error'
      ? getApiErrorText(serverError)
      : ''

  return (
    <>
      <Alert
        open={!!serverErrorMessage}
        message={serverErrorMessage}
        variant="error"
      />
      <div className="tw-relative tw-mt-4 tw-flex tw-w-full tw-flex-col tw-gap-2 xs:tw-mt-6 md:tw-flex-row md:tw-flex-wrap md:tw-justify-between xl:tw-flex-nowrap">
        {isLoading && (
          <div className="tw-z-99999 tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-top-0" />
        )}
        <div className="tw-flex tw-w-full tw-flex-col tw-gap-2 xs:tw-flex-row">
          <PayPal
            className="tw-w-full"
            source={source}
            checkoutSuccessSource={source}
          />
          <ApplePay
            className="tw-w-full"
            source={source}
            checkoutSuccessSource={source}
          />
        </div>
        <GooglePay
          className={cn({
            'tw-pointer-events-none tw-opacity-50': isLoading,
          })}
          source={source}
          checkoutSuccessSource={source}
        />
      </div>
    </>
  )
}
